<template>
  <div class="gift CheckoutFreeGift">
    <div class="selectNumber w-full">
      <h5 class="m-0 text-NotoSansRegular selectGift_bg px-6 py-4 text-white relative arrow md:font-semibold text-sm">{{ giftData.name }}</h5>
      <h5 class="m-0 text-NotoSansRegular px-6 py-4 selectGift_color md:font-semibold text-sm">贈品：您已選了<span>{{ selectedGifts.length }}</span>件商品，還可再選
        <span>{{ remainGiftSelect }}</span>件商品
      </h5>
    </div>
    <div class="giftList flex">
      <div class="w-full md:px-3">
        <div class="container relative">
          <swiper :options="freeGiftOption" class="swiper h-full swiper_list">
            <swiper-slide v-for="(item, index) in giftData.gift_options" :key="index" :class="{ selected: selectedGifts.findIndex(x => x.id === item.id) > -1 }" class="pt-3 pb-2 md:pt-8 md:pb-5 gift-item cursor-pointer h-auto md:h-full">
              <span class="absolute right-0 md:right-auto md:left-0 top-0 text-xs p-1 bgLiveBlack text-white" v-if="item.out_of_stock">已贈送完畢</span>
              <label @click="selectItem(item)" :for="'radio-input-' + selectedGifts.findIndex(x => x.id === item.id)" class="w-full h-full input-helper input-helper--radio cursor-pointer inline-flex md:block items-center">
                <div class="w-1/3 md:w-auto">
                  <div class="gift-inner bg-white">
                    <div v-if="item.cover!==''" class="square-img" v-lazy:background-image="{ src: item.cover }"></div>
                    <div v-if="item.cover===''" class="square-img square-img-none"></div>
                  </div>
                </div>
                <div class="giftName text-NotoSansRegular text-sm text-left mt-1 md:mt-3 mx-auto pl-2 w-2/3 md:w-10/12">
                  <font-awesome-icon :icon="['far', 'check-square']" v-if="selectedGifts.findIndex(x => x.id === item.id) > -1" class="text-xl md:text-base" />
                  <font-awesome-icon :icon="['far', 'square']" v-else  class="text-xl md:text-base" />
                  <span class="text-left leading-normal ml-1">{{ item.name }}</span>
                </div>
              </label>

              <div class="peirod px-3 mt-3 text-xs" v-if="item.type === 'SUBSCRIPTION' && item.months > 0">
                <span class="text-xs whitespace-no-wrap">請選擇起訖</span>
                <div class="flex">
                  <div class="startTime w-1/2">
                    <date-picker v-if="selectedGifts.findIndex(x => x.id === item.id) < 0" v-model="item.begin_at" valueType="format" type="month" placeholder="請選擇" :disabled-date="disabledDate" :input-class="'input-class'" :disabled="item.out_of_stock"></date-picker>
                    <date-picker v-else disabled v-model="hasSelectedItems[selectedGifts.findIndex(x => x.id === item.id)].begin_at" valueType="format" type="month" placeholder="請選擇" :disabled-date="disabledDate" :input-class="'input-class'"></date-picker>
                  </div>
                  <div class="endTime flex items-center">
                    <p class="" v-if="selectedGifts.findIndex(x => x.id === item.id) < 0">~ {{ getEnd_at(item, index) }}</p>
                    <p class="" v-else>~ {{ hasSelectedItems[selectedGifts.findIndex(x => x.id === item.id)].end_at }}</p>
                  </div>
                </div>
              </div>
            </swiper-slide>

          </swiper>
          <div class="swiper-button-next swiper-button-next-gift focus:outline-none cursor-pointer py-16 mt-0 hidden md:block" v-if="giftData.gift_options.length > 4"></div>
          <div class="swiper-button-prev swiper-button-prev-gift focus:outline-none cursor-pointer py-16 mt-0 hidden md:block" v-if="giftData.gift_options.length > 4"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sweetAlert from '@/components/modules/sweetAlert'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import moment from 'moment'
export default {
  name: 'CheckoutFreeGift',
  components: {
    DatePicker
  },
  props: {
    giftData: {
      type: Object
    },
    hasSelectedItems: {
      type: Array
    }
  },
  mixins: [
    sweetAlert
  ],
  data () {
    return {
      renderComponent: true,
      selectedGifts: [],
      freeGiftOption: {
        direction: 'horizontal',
        slidesPerView: 4,
        spaceBetween: 5,
        loop: false,
        navigation: {
          enabled: false,
          nextEl: '.swiper-button-next-gift',
          prevEl: '.swiper-button-prev-gift'
        },
        breakpoints: {
          576: {
            direction: 'vertical',
            mousewheelControl: true,
            slidesPerView: 3,
            freeMode: true,
            freeModeSticky: true,
            navigation: {
              enabled: false
            }
          }
        }
      },

      begin_at: null,
      end_at: null,
      // 起訖日期
      disabledDate (date) {
        // 當月不算，往後12個月，2024/4/30行銷部要求修改
        // 當月~當月+12，2025/12/31行銷部要求修改
        const now = new Date()
        // 當月第一天
        const start = new Date(now.getFullYear(), now.getMonth(), 1)

        // 當月 + 12 個月的最後一天
        const end = new Date(now.getFullYear(), now.getMonth() + 13, 0)

        return date < start || date > end
      }
    }
  },
  watch: {
  },

  computed: {
    remainGiftSelect () {
      if (this.giftData.gift_options !== null) {
        return this.giftData.action_quantity - this.selectedGifts.length
      } else {
        return 0
      }
    }
  },
  mounted () {
    this.selectedGifts = this.hasSelectedItems
  },
  methods: {
    selectItem (item) {
      const selectedIdx = this.selectedGifts.findIndex(x => x.id === item.id)
      const isSelected = selectedIdx > -1

      // 1. 缺貨
      if (item.out_of_stock) {
        this.$swal.fire({
          icon: 'info',
          title: 'Oops...',
          text: `${item.name} 已贈送完畢`,
          customClass: { confirmButton: 'bgLiveABCRed' }
        })
        return
      }

      // 2. 訂閱型必須先選時間（僅在「尚未選過」時檢查）
      if (
        item.type === 'SUBSCRIPTION' &&
        !item.begin_at &&
        !isSelected
      ) {
        this.$swal.fire({
          icon: 'info',
          title: 'Oops...',
          text: '請先選擇起訂月份再勾選雜誌',
          customClass: { confirmButton: 'bgLiveABCRed' }
        })
        return
      }

      // 3. 已選 → 取消選取
      if (isSelected) {
        this.selectedGifts.splice(selectedIdx, 1)
        this.emitItem()
        return
      }

      // 4. 尚未選，但名額已滿
      if (this.remainGiftSelect === 0) {
        this.alertPop(
          'warning',
          `贈品只能選擇 ${this.giftData.action_quantity} 件，若要更改，請先取消已勾選的贈品`
        )
        return
      }

      // 5. 新增選取
      const gift =
        item.type === 'SUBSCRIPTION'
          ? { id: item.id, begin_at: item.begin_at, end_at: item.end_at }
          : { id: item.id }

      this.selectedGifts.push(gift)
      this.emitItem()
    },
    // selectItem (item) {
    //   console.log(item)
    //   let hasSelectedIdx = this.selectedGifts.findIndex(x => x.id === item.id)
    //   if (item.out_of_stock) {
    //     this.$swal.fire({
    //       icon: 'info',
    //       title: 'Oops...',
    //       text: `${item.name} 已贈送完畢`,
    //       customClass: {
    //         confirmButton: 'bgLiveABCRed'
    //       }
    //     })
    //     return
    //   }
    //   if (item.type === 'SUBSCRIPTION' && !item.begin_at && hasSelectedIdx < 0) {
    //     this.$swal.fire({
    //       icon: 'info',
    //       title: 'Oops...',
    //       text: `請選擇時間`,
    //       customClass: {
    //         confirmButton: 'bgLiveABCRed'
    //       }
    //     })
    //     return
    //   }

    //   if (this.remainGiftSelect && hasSelectedIdx < 0) {
    //     if (item.type === 'SUBSCRIPTION') {
    //       this.selectedGifts.push({ id: item.id })
    //     } else {
    //       this.selectedGifts.push({ id: item.id, begin_at: item.begin_at, end_at: item.end_at })
    //     }
    //   } else if (hasSelectedIdx > -1) {
    //     this.selectedGifts.splice(hasSelectedIdx, 1)
    //   } else if (this.remainGiftSelect === 0 && hasSelectedIdx < 0) {
    //     this.alertPop('warning', `贈品只能選擇 ${this.giftData.action_quantity} 件，若要更改，請先取消已勾選的贈品`)
    //     return
    //   }

    //   this.emitItem()
    // },
    emitItem () {
      let arr = {
        'id': this.giftData.id,
        'selected_gifts': this.selectedGifts
      }
      this.$emit('getSelectGift', arr)
    },
    getEnd_at (item, index) {
      if (item.months && item.begin_at) {
        const months = item.months - 1
        const startDate = new Date(item.begin_at)
        const endDate = moment(startDate).add(months, 'months')

        this.giftData.gift_options[index].end_at = moment(endDate).format('YYYY-MM')
        return moment(endDate).format('YYYY-MM')
      }
      return null
    }
  }
}
</script>

<style lang="scss">
.swiper-button-next-gift {
    right: -1.5rem;
    background-image: url('~@/assets/btn/arrow_circle_up.png');
    width: 40px !important;
    height: 100% !important;
    transform: translateY(-50%);
    margin-top: 0 !important;
    background-size: 30px 30px !important;
    background-position: center;
    @media (min-width: 576px) {
      width: 5% !important;
    }
    @media (min-width: 1024px) {
      right: -2.5rem;
    }
  }
  .swiper-button-prev-gift {
    left: -1.5rem;
    background-image: url('~@/assets/btn/arrow_circle_down.png');
    width: 40px !important;
    height: 100% !important;
    transform: translateY(-50%);
    margin-top: 0 !important;
    background-size: 30px 30px !important;
    background-position: center;
    @media (min-width: 576px) {
      width: 5% !important;
    }
    @media (min-width: 1024px) {
      left: -2.5rem;
    }
  }
  .gift {
    .selectNumber {
        .arrow:after{
          display: block;
          content:'';
          border-width:8px 8px 8px 8px;
          border-style:solid;
          border-color:#EF0B0B transparent transparent transparent;

          /* 定位 */
          position:absolute;
          left: 30px;
          top:100%;
        }
        h5 {
          color: #434343;
          letter-spacing: .2rem;
        }
        .selectGift_bg {
          background-color: #EF0B0B;
        }
        .selectGift_color {
          color: #EF0B0B;
        }
      }
    .giftList {
      min-height: 300px;
      .gift-item {
        border: 0.5px solid #4B4B4B;
        .gift-inner {
          margin: 0 auto;
          position: relative;
          width: 60%;
          padding-bottom : 60%;
          background-position: center center;
          background-repeat: no-repeat;
          background-size: cover;
          background-color: white;
          border: 0.5px solid #484848;
          .square-img {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            width: 90%;
            padding-bottom : 90%;
            background-position: center center;
            background-repeat: no-repeat;
            background-size: contain;
          }
          .square-img-none {
            background-image: url('~@/assets/images/preset_item.png');
          }
        }
      }
      .selected {
        border: 0.5px solid #FDD8D8;
        background: #FDD8D8;
        height: 100%;
        .gift-inner {
          border: 0.5px solid #FDD8D8;
        }
      }

    }
  }
  .swiper_list {
    // height: 330px !important;
    overflow-y: scroll;
    @media (min-width: 576px) {
      height: auto !important;
      overflow-y: auto;
    }
  }
  .startEndTime {
    .startTime {
      width: 46%;
    }
    .endTime {
      width: 46%;
    }
  }
  .input-class {
    display: inline-block;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 100%;
    height: 38px;
    padding-left: 0.5rem;
    font-size: 14px;
    line-height: 1.4;
    color: #555555;
    background-color: #fff;
    border: 1px solid #555555;
    border-radius: 4px;
    -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
    box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
  }
  .CheckoutFreeGift {
    .mx-datepicker {
      width: 100%;
    }
  }

</style>
